import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { Location } from "../../../@types/location";
import { RootState } from "../../rootReducer";

// Busqueda de Locations
export const findLocations = createAsyncThunk(
  "userProfileLocation/findLocations",
  async (location, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {
      // Busca los primeros 10.000 locations y los ordena por nombre
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const response = await fetch(
        `${api.baseURL}location?limit=10000&sort=name%20ASC&where={"sourceOrganization":"${state.userAuthentication.user?.sourceOrganization}"}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const data = await response.json();
      return data as Location[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
